import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";
import {
  CURRENCY_SYMBOLS,
  formatCurrency,
  cleanNumber,
} from "../../../../../../DashboardDesktop/Anomalies/AnomaliesTabs/Utils/anomaliesColumns";

interface MissingDataItemMoreMetricsProps {
  row: Record<string, any>;
}

const metricRow = (label: string, value: string) => (
  <>
    <ListItem
      sx={{
        width: "100%",
        display: "block",
        p: spacing.Spacing.sm.$value,
      }}
    >
      <Typography
        sx={{
          fontSize: typography.Size.Text.xs.$value,
          lineHeight: typography.Line_height.text.xs.$value,
          fontWeight: typography.Font_weight.Medium.$value,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {label}
        <Box
          sx={{
            fontWeight: typography.Font_weight.Semibold.$value,
            fontSize: typography.Size.Text.xs.$value,
          }}
        >
          {value}
        </Box>
      </Typography>
    </ListItem>
    <Divider />
  </>
);

const MissingDataCardItemMoreMetrics = ({
  row,
}: MissingDataItemMoreMetricsProps) => {
  const usd = CURRENCY_SYMBOLS.USD;
  return (
    <Stack>
      <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
        {metricRow("TOTAL INCOME $", formatCurrency(row.total_income_dollar, usd))}
        {metricRow("NET REV", formatCurrency(row.net_rev, usd))}
        {metricRow("EPC", formatCurrency(row.EPC, usd))}
        {metricRow("ROI", `${Math.round(cleanNumber(row.ROI_perc))}%`)}
        {metricRow("PV", formatCurrency(row.PV, usd))}
      </List>
    </Stack>
  );
};

export default MissingDataCardItemMoreMetrics;
